/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import MapperGrid from "./MapperGrid";
import { GetAllDatabases } from "../../redux/actions/connector";
import { useParams, useHistory } from "react-router";
import "./Connector.css";
import "./style.css";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backButton: {
    backgroundColor: "#f7c948",
    boxShadow: "0px 3px 6px #00000029",
    padding: "1vh 1vw",
    outline: "none",
    textDecoration: "none",
    border: "none",
    borderRadius: "6px",
    color: "white",
    marginBottom: "1%",
  },
}));

const SqlMapper = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const history = useHistory();
  const { orgId, credentialId } = useParams();

  useEffect(() => {
    dispatch(GetAllDatabases());
  }, []);

  const goBack = () => {
    history.goBack();
  };
  const handleBackButtonClick = () => {
    window.history.back();
  };

  return (
    <div>
      <div>
        <button onClick={handleBackButtonClick} className={classes.backButton}>
          Back
        </button>
      </div>
      <div>
        <h5 className="mb-1">
          <span
            style={{ cursor: "pointer" }}
            onClick={goBack}
            className="text-primary"
          >
            Connectors
          </span>{" "}
          {">"} Mappers
        </h5>
      </div>

      <MapperGrid connectorId={credentialId} selectedOrg={orgId} />
    </div>
  );
};

export default SqlMapper;
